import {batchGetPackageSummaryForTrackingId} from "../../../../commons/api/BatchGetPackageSummaryResults";
import {getFeatureStatus} from "../../../../commons/CommonUtils.js";
import {FEATURES, PACKAGE_SEARCH_API_CHUNK_SIZE} from "../../../../commons/constants/CommonConstants";

const BATCH_SIZE = 500;

export const fetchBatchPackageSummary = async (trackingIds) => {
    // Reduce the BatchGetPackageSummary chunk size to 200 when isPackageSearchReducedChunkSizeEnabled
    const isReducedChunkSizeEnabled = await getFeatureStatus(FEATURES.IS_PACKAGE_SEARCH_REDUCED_CHUNK_SIZE_ENABLED);
    const batchSize = isReducedChunkSizeEnabled ? PACKAGE_SEARCH_API_CHUNK_SIZE : BATCH_SIZE;
    const results = [];

    for (let i = 0; i < trackingIds.length; i += batchSize) {
        const batch = trackingIds.slice(i, i + batchSize);
        const result = await batchGetPackageSummaryForTrackingId(batch)
        results.push(result);
    }
    const combinedResults = results.flat();
    return combinedResults;

}


// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/BatchPackageSummary.js